<div class="footer">
    <span>© Volkswagen Group of America,Inc. All rights reserved</span>
</div>